<template>
    <div style="background:#fff">
        <div style="width:1400px; margin:0 auto; padding:10px 0;">
            <a-breadcrumb class="page_breadcrumb">
                <a-breadcrumb-item><router-link :to="{name:'menu'}">游戏专项</router-link></a-breadcrumb-item>
                <a-breadcrumb-item>{{parent}}</a-breadcrumb-item>
                <a-breadcrumb-item>{{name}}</a-breadcrumb-item>
            </a-breadcrumb>
        </div>
        <div class="nsh2ce_ctrl_container nsh2ce">

            <!-- 逆水寒board -->
            <div class="nsh2ce_board">
                <div class="board-content">
                    <div class="board-item" v-for="(it, key) in datas.board" :key="key">
                        <span>登录账号：{{ it.login || '-' }}</span>
                        <span  v-if="key!=1">{{ key==2 ? '次': key }}日留存：{{ it.liucun || '-' }}</span>
                    </div>
                </div>
            </div>

            <!-- 表格 -->
            <div class="nsh2ce_ctrl_tables" v-for="table in [2, 0, 1, 3]" :key="table">
                <div class="table_title">
                    <h2>{{ datas.results[table].title }}</h2>
                </div>
                <ul class="nav-group" v-if="table!=3">
                    <li class="text">分组选择：</li>
                    <li role="presentation" :class="{active: datas.results[table].active == it.id}" v-for="it in datas.results[table].groupNav" @click="select(table, it.id)" :key="it.title">
                        <a href="javascript:;">{{ it.title }}</a>
                    </li>
                </ul>
                <DataTable :fields="datas.results[table].thead" :datas="datas.results[table].data" class="nsh2ce_ctrl_table" :paging="false" :lock="table==3?true:false" :ref="`table_${table}`"/>
                <div class="tips">
                    <p class="tip" v-if="table!=3">登录、留存：首日激活账号后续的登录、留存情况；<br />平均在线时长：截止到数据获取时该组别玩家平均在线时长（分钟）</p>
                    <p class="tip" v-if="table==3">参与率：参与角色ID数/可参加等级及以上登录角色ID数；<br />完成率：完成角色ID数/参与角色ID数<br />（如玩法有多个任务或多个副本，角色通过一个任务或副本即为完成，次数完成率详见玩法参与率完成率）</p>
                </div>
                <!-- <DataTable :fields="it.thead" :datas="it.tbody" class="nsh2ce_ctrl_table" :paging="false"/>
                <div class="tips">
                    <p v-for="t in it.tips" :key="t">{{ t }}</p>
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
const groupNav = [
  { id: 0, title: '重点', sub: [{ id: 1, title: '标准新玩家（2286）' }, { id: 2, title: '男' }, { id: 3, title: '女' }, { id: 4, title: '学生' }, { id: 5, title: '上班族' }, { id: 6, title: '天刀组' }, { id: 7, title: '剑网组' }, { id: 8, title: '传统3D模式组' }, { id: 9, title: '2.5D操作模式组' }, { id: 10, title: '可接受多种操作模式组' }, { id: 11, title: '特殊：偏好动作（33）' }, { id: 12, title: '特殊：老玩家（273）' }] },
  { id: 'innergame', title: '游戏内属性', sub: [{ id: 1, title: '游戏内2.5D模式' }, { id: 2, title: '游戏内自在模式' }, { id: 3, title: '游戏内传统3D模式' }, { id: 4, title: '游戏内动作模式' }, { id: 5, title: '常用自动寻路' }, { id: 6, title: '常用探索模式' }] },
  { id: 'gender', title: '性别', sub: [{ id: 1, title: '男' }, { id: 2, title: '女' }] },
  { id: 'age', title: '年龄', sub: [{ id: 1, title: '00后(18岁以下)' }, { id: 2, title: '95后(19~23岁)' }, { id: 3, title: '90后(24~28岁)' }, { id: 4, title: '85后(29~33岁)' }, { id: 5, title: '80后(34~38岁)' }, { id: 6, title: '80前(39岁及以上)' }] },
  { id: 'occupation', title: '职业', sub: [{ id: 1, title: '私企老板/个体经营者/小商贩' }, { id: 2, title: '企业/事业单位/政府工作人员' }, { id: 3, title: '工厂/服务工作者' }, { id: 4, title: '中小学生' }, { id: 5, title: '在校大学生' }, { id: 6, title: '自由职业者' }, { id: 7, title: '零工/散工/待业人员' }] },
  { id: 'occupation_gender', title: '职业(分性别)', sub: [{ id: 1, title: '私企老板/个体经营者/小商贩（男）' }, { id: 2, title: '私企老板/个体经营者/小商贩（女）' }, { id: 3, title: '企业/事业单位/政府工作人员（男）' }, { id: 4, title: '企业/事业单位/政府工作人员（女）' }, { id: 5, title: '工厂/服务工作者（男）' }, { id: 6, title: '工厂/服务工作者（女）' }, { id: 7, title: '中小学生（男）' }, { id: 8, title: '中小学生（女）' }, { id: 9, title: '在校大学生（男）' }, { id: 10, title: '在校大学生（女）' }, { id: 11, title: '自由职业者（男）' }, { id: 12, title: '自由职业者（女）' }, { id: 13, title: '零工/散工/待业人员（男）' }, { id: 14, title: '零工/散工/待业人员（女）' }] },
  { id: 'game_played', title: '各类端游经历', sub: [{ id: 1, title: '天刀' }, { id: 2, title: '剑网三' }, { id: 3, title: '天谕' }, { id: 4, title: '天下' }, { id: 5, title: '倩女' }, { id: 6, title: '魔兽' }, { id: 7, title: '九阴' }, { id: 8, title: '天龙八部' }, { id: 9, title: '笑傲江湖' }, { id: 10, title: '武魂' }, { id: 11, title: '梦幻西游' }, { id: 12, title: '古剑奇谭' }, { id: 13, title: 'LOL' }, { id: 14, title: '剑灵' }, { id: 15, title: '大话西游' }, { id: 16, title: '镇魔曲' }, { id: 17, title: '暗黑' }, { id: 18, title: '剑侠情缘（除剑网3）' }, { id: 19, title: '洛奇英雄传' }, { id: 20, title: '绝地求生大逃杀' }, { id: 21, title: 'CSGO' }] },
  { id: 'play_time', title: '每日玩端游时长习惯', sub: [{ id: 0, title: '1小时以内' }, { id: 3, title: '1-2小时' }, { id: 4, title: '2-4小时' }, { id: 5, title: '4小时以上' }] },
]

const groupKey = groupNav.reduce((ret, it) => {
  ret[it.id] = it.sub.reduce((rret, iit) => {
    rret[iit.id] = iit.title
    return rret
  }, {})
  return ret
}, {})

const groupNav2 = [
  { id: 2, title: '标准玩家', sub: [{ id: 1, title: '标准新玩家（仅按照年龄修正）' }, { id: 2, title: '标准新玩家（仅按照性别修正）' }, { id: 3, title: '标准新玩家（按照年龄性别修正）' }] },
  { id: 'age_xiuzheng', title: '年龄（仅按照年龄修正）', sub: [{ id: 1, title: '00后(18岁以下)' }, { id: 2, title: '95后(19~23岁)' }, { id: 3, title: '90后(24~28岁)' }, { id: 4, title: '85后(29~33岁)' }, { id: 5, title: '80后(34~38岁)' }, { id: 6, title: '80前(39岁及以上)' }] },
]

const groupKey2 = groupNav2.reduce((ret, it) => {
  ret[it.id] = it.sub.reduce((rret, iit) => {
    rret[iit.id] = iit.title
    return rret
  }, {})
  return ret
}, {})

const groupNav1 = [
  { id: 'all_video_card', title: '全部', sub: [{ id: 1, title: '高端显卡' }, { id: 2, title: '中端显卡' }, { id: 3, title: '低端显卡' }] },
  { id: 'male_video_card', title: '男', sub: [{ id: 1, title: '高端显卡' }, { id: 2, title: '中端显卡' }, { id: 3, title: '低端显卡' }] },
  { id: 'female_video_card', title: '女', sub: [{ id: 1, title: '高端显卡' }, { id: 2, title: '中端显卡' }, { id: 3, title: '低端显卡' }] },
  { id: 'all_student_video_card', title: '学生', sub: [{ id: 1, title: '高端显卡' }, { id: 2, title: '中端显卡' }, { id: 3, title: '低端显卡' }] },
  { id: 'all_workers_video_card', title: '上班族', sub: [{ id: 1, title: '高端显卡' }, { id: 2, title: '中端显卡' }, { id: 3, title: '低端显卡' }] },
  { id: 'age90_video_card', title: '90后', sub: [{ id: 1, title: '高端显卡' }, { id: 2, title: '中端显卡' }, { id: 3, title: '低端显卡' }] },
  { id: 'age95_video_card', title: '95后', sub: [{ id: 1, title: '高端显卡' }, { id: 2, title: '中端显卡' }, { id: 3, title: '低端显卡' }] },
  { id: 'is_tiandao_video_card', title: '天刀组', sub: [{ id: 1, title: '高端显卡' }, { id: 2, title: '中端显卡' }, { id: 3, title: '低端显卡' }] },
  { id: 'is_jianwang3_video_card', title: '剑网组', sub: [{ id: 1, title: '高端显卡' }, { id: 2, title: '中端显卡' }, { id: 3, title: '低端显卡' }] },
  { id: '3d_video_card', title: '传统3D模式', sub: [{ id: 1, title: '高端显卡' }, { id: 2, title: '中端显卡' }, { id: 3, title: '低端显卡' }] },
  { id: '2half5d_video_card', title: '2.5D操作模式', sub: [{ id: 1, title: '高端显卡' }, { id: 2, title: '中端显卡' }, { id: 3, title: '低端显卡' }] },
  { id: 'many_modes_video_card', title: '可接受多种操作模式', sub: [{ id: 1, title: '高端显卡' }, { id: 2, title: '中端显卡' }, { id: 3, title: '低端显卡' }] },
]

const groupKey1 = groupNav1.reduce((ret, it) => {
  ret[it.id] = it.sub.reduce((rret, iit) => {
    rret[iit.id] = iit.title
    return rret
  }, {})
  return ret
}, {})

import DataTable from '@/components/common/datatable.vue'
import {ctrlMixin} from '@/utils/ctrlMixin.js'
export default {
    mixins: [ctrlMixin],
    name:'nsh2ce',
    props: ['parent', 'name'],
    components: {
        DataTable,
    },
    mounted(){
        this.initData()
        this.$refs.table_3[0].lockHeader(true)
    },
    data() {
        return {
            datas: {
                board: {},
                results: [{
                    title: '玩家留存情况',
                    active:0,
                    groupNav,
                    groupKey,
                    thead: [{id:'title', title:'组别'}, {title:'首日', children: [{id:'first_account_cnt', title:'登录'}, {id:'online_0', title:'在线'}]}, {title:'次日', children: [{id:'lc_1', title:'留存'}, {id:'online_1', title:'在线'}]}, {title:'第3日', children: [{id:'lc_2', title:'留存'}, {id:'online_2', title:'在线'}]}, {title:'第4日', children: [{id:'lc_3', title:'留存'}, {id:'online_3', title:'在线'}]}, {title:'第5日', children: [{id:'lc_4', title:'留存'}, {id:'online_4', title:'在线'}]}, {title:'第6日', children: [{id:'lc_5', title:'留存'}, {id:'online_5', title:'在线'}]}, {title:'第7日', children: [{id:'lc_6', title:'留存'}, {id:'online_6', title:'在线'}]}, {title:'第8日', children: [{id:'lc_7', title:'留存'}, {id:'online_7', title:'在线'}]}, {title:'第9日', children: [{id:'lc_8', title:'留存'}, {id:'online_8', title:'在线'}]}, {title:'第10日', children: [{id:'lc_9', title:'留存'}, {id:'online_9', title:'在线'}]}, {title:'第11日', children: [{id:'lc_10', title:'留存'}, {id:'online_10', title:'在线'}]}, {title:'第12日', children: [{id:'lc_11', title:'留存'}, {id:'online_11', title:'在线'}]}, {title:'第13日', children: [{id:'lc_12', title:'留存'}, {id:'online_12', title:'在线'}]}, {title:'第14日', children: [{id:'lc_13', title:'留存'}, {id:'online_13', title:'在线'}]}],
                    data: null,
                }, {
                    title: '玩家硬件分组留存情况',
                    active:'all_video_card',
                    groupNav: groupNav1,
                    groupKey: groupKey1,
                    thead: [{id:'title', title:'组别'}, {title:'首日', children: [{id:'first_account_cnt', title:'登录'}, {id:'online_0', title:'在线'}]}, {title:'次日', children: [{id:'lc_1', title:'留存'}, {id:'online_1', title:'在线'}]}, {title:'第3日', children: [{id:'lc_2', title:'留存'}, {id:'online_2', title:'在线'}]}, {title:'第4日', children: [{id:'lc_3', title:'留存'}, {id:'online_3', title:'在线'}]}, {title:'第5日', children: [{id:'lc_4', title:'留存'}, {id:'online_4', title:'在线'}]}, {title:'第6日', children: [{id:'lc_5', title:'留存'}, {id:'online_5', title:'在线'}]}, {title:'第7日', children: [{id:'lc_6', title:'留存'}, {id:'online_6', title:'在线'}]}, {title:'第8日', children: [{id:'lc_7', title:'留存'}, {id:'online_7', title:'在线'}]}, {title:'第9日', children: [{id:'lc_8', title:'留存'}, {id:'online_8', title:'在线'}]}, {title:'第10日', children: [{id:'lc_9', title:'留存'}, {id:'online_9', title:'在线'}]}, {title:'第11日', children: [{id:'lc_10', title:'留存'}, {id:'online_10', title:'在线'}]}, {title:'第12日', children: [{id:'lc_11', title:'留存'}, {id:'online_11', title:'在线'}]}, {title:'第13日', children: [{id:'lc_12', title:'留存'}, {id:'online_12', title:'在线'}]}, {title:'第14日', children: [{id:'lc_13', title:'留存'}, {id:'online_13', title:'在线'}]}],
                    data: null,
                }, {
                    title: '玩家留存预估',
                    active:2,
                    groupNav: groupNav2,
                    groupKey: groupKey2,
                    thead: [{id:'title', title:'组别'}, {title:'首日', children: [{id:'first_account_cnt', title:'登录'}, {id:'online_0', title:'在线'}]}, {title:'次日', children: [{id:'lc_1', title:'留存'}, {id:'online_1', title:'在线'}]}, {title:'第3日', children: [{id:'lc_2', title:'留存'}, {id:'online_2', title:'在线'}]}, {title:'第4日', children: [{id:'lc_3', title:'留存'}, {id:'online_3', title:'在线'}]}, {title:'第5日', children: [{id:'lc_4', title:'留存'}, {id:'online_4', title:'在线'}]}, {title:'第6日', children: [{id:'lc_5', title:'留存'}, {id:'online_5', title:'在线'}]}, {title:'第7日', children: [{id:'lc_6', title:'留存'}, {id:'online_6', title:'在线'}]}, {title:'第8日', children: [{id:'lc_7', title:'留存'}, {id:'online_7', title:'在线'}]}, {title:'第9日', children: [{id:'lc_8', title:'留存'}, {id:'online_8', title:'在线'}]}, {title:'第10日', children: [{id:'lc_9', title:'留存'}, {id:'online_9', title:'在线'}]}, {title:'第11日', children: [{id:'lc_10', title:'留存'}, {id:'online_10', title:'在线'}]}, {title:'第12日', children: [{id:'lc_11', title:'留存'}, {id:'online_11', title:'在线'}]}, {title:'第13日', children: [{id:'lc_12', title:'留存'}, {id:'online_12', title:'在线'}]}, {title:'第14日', children: [{id:'lc_13', title:'留存'}, {id:'online_13', title:'在线'}]}],
                    data: null,
                }, {
                    title: '玩法参与情况',
                    thead: [{id:'title', title:'玩法'}, {title:'首日', children: [{id:'part_0', title:'参与率'}, {id:'finish_0', title:'完成率'}]}, {title:'次日', children: [{id:'part_1', title:'参与率'}, {id:'finish_1', title:'完成率'}]}, {title:'第3日', children: [{id:'part_2', title:'参与率'}, {id:'finish_2', title:'完成率'}]}, {title:'第4日', children: [{id:'part_3', title:'参与率'}, {id:'finish_3', title:'完成率'}]}, {title:'第5日', children: [{id:'part_4', title:'参与率'}, {id:'finish_4', title:'完成率'}]}, {title:'第6日', children: [{id:'part_5', title:'参与率'}, {id:'finish_5', title:'完成率'}]}, {title:'第7日', children: [{id:'part_6', title:'参与率'}, {id:'finish_6', title:'完成率'}]}, {title:'第8日', children: [{id:'part_7', title:'参与率'}, {id:'finish_7', title:'完成率'}]}, {title:'第9日', children: [{id:'part_8', title:'参与率'}, {id:'finish_8', title:'完成率'}]}, {title:'第10日', children: [{id:'part_9', title:'参与率'}, {id:'finish_9', title:'完成率'}]}, {title:'第11日', children: [{id:'part_10', title:'参与率'}, {id:'finish_10', title:'完成率'}]}, {title:'第12日', children: [{id:'part_11', title:'参与率'}, {id:'finish_11', title:'完成率'}]}, {title:'第13日', children: [{id:'part_12', title:'参与率'}, {id:'finish_12', title:'完成率'}]}, {title:'第14日', children: [{id:'part_13', title:'参与率'}, {id:'finish_13', title:'完成率'}]}],
                    data:null
                }],
            },
            timer: {
                normal: null
            }
        }
    },
    methods: {
        initData() {
            this.loading = true
            let q_board = this.$service.query(this.queryId, {mode:'board'});
            let q_lc1 = this.$service.query(this.queryId, {flag:0, subtype:0});
            let q_lc2 = this.$service.query(this.queryId, {flag:1, subtype:'all_video_card'});
            let q_lc3 = this.$service.query(this.queryId, {flag:2, subtype:2});
            let q_task = this.$service.query(this.queryId, {mode:'task'});
            
            Promise.all([q_board, q_lc1, q_lc2, q_lc3, q_task]).then((datas) => {
                this.datas.board = datas[0]
                datas[1].forEach((row, index)=>{
                    row.id = index+1
                    row.title = this.datas.results[0].groupKey[0][row.id]
                })
                datas[2].forEach((row, index)=>{
                    row.title = this.datas.results[1].groupKey['all_video_card'][row.id]
                })
                datas[3].forEach((row, index)=>{
                    row.id = index+1
                    row.title = this.datas.results[2].groupKey[2][row.id]
                })

                this.datas.results[0].data = datas[1]
                this.datas.results[1].data = datas[2]
                this.datas.results[2].data = datas[3]
                this.datas.results[3].data = datas[4]
                this.loading = false
            }).catch((errors)=>{
                console.log(errors)
                this.loading = false
            })
        },
        select(index, id) {
            if (id === this.datas.results[index].active) {
                return
            }
            this.datas.results[index].active = id
            this.datas.results[index].data = this.datas.results[index].groupNav.filter(it => it.id === id)[0].sub

            this.$service.query(this.queryId, {flag:index, subtype:id}).then((data)=>{
                if (id === 0 || id === 2 || id === 'game_played' || id === 'innergame') {
                    data.forEach((it, idx) => {
                        it.id = idx + 1
                    })
                }
                data.forEach((it) => {
                    it.title = this.datas.results[index].groupKey[id][it.id]
                })
                this.datas.results[index].data = data
            })
        },
    }
}
</script>
<style lang="less">
@width:1500px;

// 刷新按钮动画
@keyframes scale {
    0% {
        transform: scale(1);
        opacity: .7
    }
    50% {
        transform: scale(1.5);
        opacity: 0
    }
    99% {
      transform: scale(1);
      opacity: 0
    }
    100% {
        transform: scale(1);
        opacity: .7
    }
}

@keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg)
    }

    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg)
    }
}

.nsh2ce_ctrl_container {
    overflow: hidden;
    min-height: 700px;
    color:#a89371;
    .nsh2ce_ctrl_content_container {
        width:@width;
        margin:0 auto;
    }
    .nsh2ce_ctrl_title {
        height:100px;
        width:100%;
        margin:0 0 40px 0;
        .refresh_btn {
            position:absolute;
            left: 50%;
            margin:25px 0 0 250px;
            width: 50px;
            height: 50px;
            text-align: center;
            cursor: pointer;
            border-width: 0;
            background-color: transparent;
            color: rgba(0, 0, 0, .3);

            i {
                font-size: 25px;
                line-height: 55px;
            }
            &:hover {
                animation: spin 2s infinite linear;
            }
            &:hover:after {
                animation: none;
            }
            &:after {
                content: "";
                position: absolute;
                left: 0;
                top: 0;
                height: 50px;
                width: 50px;
                border-radius: 100%;
                border: 1px solid rgba(0, 0, 0, .3);
                animation: scale 2s ease infinite;
            }
        }
    }

    .nsh2ce_ctrl_tables {
        margin:0 auto;
        margin-top:20px;
        margin-bottom:30px;
        width: 1600px;
        .table_title {
            position: relative;
            text-align: center;
            margin:50px 0 30px 0;
            h2 {
                color: #a89371; 
                font-size:20px;
                &:before {
                    position:absolute;
                    content:' ';
                    top: 50%;
                    left:0;
                    width:40%;
                    border-bottom: 1px solid #a89371;
                }
                &:after {
                    position:absolute;
                    content:' ';
                    top: 50%;
                    right:0;
                    width:40%;
                    border-bottom: 1px solid #a89371;
                }
            }
        }
        .nsh2ce_ctrl_table {
            .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th {
                padding:5px 0;
            }
            .ant-table-tbody > tr:nth-child(2n) td{
                background:#e9e9e9;
            }
            .ant-table-tbody > tr:hover td{
                background:#e6f7ff;
            }
            .data_table .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td > div {
                padding: 5px 0px;
            }

            .ant-table-middle > .ant-table-content > .ant-table-scroll > .ant-table-header > table > .ant-table-thead > tr > th {
                padding:5px 0;
            }
            .ant-table-middle > .ant-table-content > .ant-table-scroll > .ant-table-body > table > .ant-table-tbody > tr > td {
                padding:5px 0;
            }
        }
        .tips {
            margin:20px 0 0 0;
            color:#777;
            text-align: center;
        }

        .nav-group {
            display: inherit;
            flex-wrap: wrap;
            li:after {
                content: "/";
                color: #bbb;
            }
            .text {
                padding: 10px;
            }
        }
        .nav-group li:first-child:after,
        .nav-group li:last-child:after,
        .nav-group .text:after {
        content: "";
        }
        .nav-group li.active a {
            color: #41cac0;
            font-weight: 600;
        }
        .nav-group a,
        .nav-group .refresh {
            color:#a89371;
            display: inline-block;
            vertical-align: middle;
            padding: 10px 15px;
            white-space: nowrap;
        }
        .nav-group .refresh {
            color: #9a7f54;
            border: 1px solid currentColor;
                border-radius: 4px;
                background-color: transparent;
        }
        .nav-group .refresh:hover {
            color: #41cac0;
        }
        .nav-group .refresh[disabled] {
            color: #aaa;
        }
        .nav-group{text-align:center}
        .nav-group li{display:inline-block;}
    }

    &.nsh2ce {
        padding:70px 0 0 0;
        background: url('../../../assets/img/ctrl/nsh/bg.jpg');
        .nsh2ce_ctrl_title {
            background: url('../../../assets/img/ctrl/nsh/2ce_title.png') center no-repeat;
        }
    }

    .nsh2ce_realtime {
        margin:20px 0 20px 0;
        .realtime_item_container {
            display: flex;
            justify-content: center;
            
            .realtime_item {
                border-radius: e('50%/50%');
                text-align: center;
                background-color: rgb(210, 179, 105);
                margin-right: 5px;
                color: #fff;
                span {
                    display: block;
                    padding: 7px 20px 3px 20px;
                    &:last-child {
                        padding: 3px 20px 7px 20px;
                        border-top: 1px solid #fff;
                    }
                }
            }
        }
        .realtime_tip {
            color: rgb(210, 179, 105);
            text-align: center;
            white-space: nowrap;
            margin:10px 0 0 0;
        }
    }

    @mainColor:#a89371;
        
    .nsh2ce_board {
        width:1440px;
        position: relative;
        margin:0 auto;
        margin-bottom: 20px;
        padding: 70px 10px 50px 25px;
        border: 10px solid #d1c0a5;
        &:before {
            content: "";
            position: absolute;
            width: 493px;
            height: 95px;
            left: 50%;
            margin-left: -246px;
            top: -60px;
            background: url(../../../assets/img/ctrl/nsh/2ce_title.png) no-repeat;
            z-index: 1;
        }
        &:after {
            content: "";
            position: absolute;
            border: 2px solid #d1c0a5;
            left: 10px;
            top: 10px;
            bottom: 10px;
            right: 10px;
            z-index: -1;
        }

        .board-content{width:1200px; margin:0 auto;}
        .board-item {
        vertical-align: top;
        width:150px;
        height:150px;
        margin:10px;
        padding:80px 15px 0 15px;
        background:rgba(200,200,200,0.1);
        color: #777;
        position: relative;
        display: inline-block;
        &:before {
            content: "";
            top: 0;
            left:0;
            z-index: 1;
            position: absolute;
            width: 150px;
            height: 60px;
            background: #eee url(../../../assets/img/ctrl/nsh/2ce_days.png) no-repeat;
        }
        }
        .board-item span{line-height:24px; color:#777; display:block}

        .board-item:nth-of-type(1):before { background-position: 0 0; }
        .board-item:nth-of-type(2):before { background-position: 0 -60px; }
        .board-item:nth-of-type(3):before { background-position: 0 -120px; }
        .board-item:nth-of-type(4):before { background-position: 0 -180px; }
        .board-item:nth-of-type(5):before { background-position: 0 -240px; }
        .board-item:nth-of-type(6):before { background-position: 0 -300px; }
        .board-item:nth-of-type(7):before { background-position: 0 -360px; }
        .board-item:nth-of-type(8):before { background-position: 0 -420px; }
        .board-item:nth-of-type(9):before { background-position: 0 -480px; }
        .board-item:nth-of-type(10):before { background-position: 0 -540px; }
        .board-item:nth-of-type(11):before { background-position: 0 -600px; }
        .board-item:nth-of-type(12):before { background-position: 0 -660px; }
        .board-item:nth-of-type(13):before { background-position: 0 -720px; }
        .board-item:nth-of-type(14):before { background-position: 0 -780px; }

        .board-item h3 {font-size:18px; margin-top: 0;margin-bottom: 0; }
        .board-item .list { padding:0; font-size:13px; line-height:20px; margin:10px 0;}
        .board-item .list li {color: #666; }
        .board-item .list a:hover{color:#9a7f54; text-decoration:underline;}
        .board-item .list-shortcut { height:120px; }
        .board-item .list:nth-of-type(2) li { padding-bottom: 5px; margin-bottom: 5px; border-bottom: 1px dashed #a89371; }
        .board-item .list:nth-of-type(2) li:last-child { border-bottom-width: 0; }
    }
}
</style>